import { createContext } from "react";

const WithdrawHistoryContext = createContext();

export default WithdrawHistoryContext;
